/** Describes where this insurance comes from. */
export enum InsuranceOrigin {
	/** There can technically be more than 1 offer in a comparison context. */
	Offer = 'OFFER',
	/** There should ever only be 1 existing insurance in a comparison context. */
	Existing = 'EXISTING',
}
